import { useChannelsByRelationshipQuery } from 'lane-shared/hooks';
import { useEffect } from 'react';
import { queryChannels } from 'lane-shared/graphql/channel';
import { useQuery } from '@apollo/client';
import { ActiveChannelTypeEnum } from 'constants-channel';
import { Channel } from 'packages/lane-shared/types/ChannelType';

export function useRelatedChannels(
  channelId: string,
  type: ActiveChannelTypeEnum
): Channel[] {
  const isPropertyChannel = type === ActiveChannelTypeEnum.Property;
  const { items, fetchNextPage, pageInfo } = useChannelsByRelationshipQuery({
    perPage: 25,
    skip: channelId === '',
    relatedTo: isPropertyChannel
      ? {
          _id: channelId,
        }
      : {
          sortBy: { key: 'name', dir: 'asc' },
          isSub: false,
        },
    channel: isPropertyChannel
      ? null
      : {
          _id: channelId,
        },
  });

  useEffect(() => {
    if (items.length < pageInfo.total) {
      fetchNextPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);

  return items.map(item => (isPropertyChannel ? item.channel : item.relatedTo));
}

export function useChannelsFromHierarchy(channelId: string | undefined) {
  const { data: buildings } = useQuery(queryChannels, {
    skip: !channelId,
    fetchPolicy: 'cache-and-network',
    variables: {
      pagination: {
        start: 0,
        perPage: 500,
      },
      search: {
        sortBy: {
          key: 'name',
          dir: 'asc',
        },
        includeChannelsFromHierarchy: true,
        isSub: false,
        parent: {
          _id: channelId,
        },
      },
    },
  });

  return buildings?.channels?.items || [];
}
